goog.provide("shadow.js.shim.module$dayjs$locale$zh_tw");
goog.provide("module$shadow_js_shim_module$dayjs$locale$zh_tw");
shadow.js.shim.module$dayjs$locale$zh_tw = shadow.js.nativeProvides["dayjs/locale/zh-tw"] = require("dayjs/locale/zh-tw");
module$shadow_js_shim_module$dayjs$locale$zh_tw.default = shadow.js.shim.module$dayjs$locale$zh_tw;
